import { InputNumber } from 'primereact/inputnumber';
import { useEffect, useState } from 'react';

type CurrencyProps = {
  defValue: number | null;
  onChange: (value: number | null) => void;
  onBlur: () => void;
  hasError: boolean;
  disabled: boolean;
  errorMessage?: string;
};

const Currency = ({
  defValue,
  onChange,
  onBlur,
  hasError,
  disabled,
  errorMessage,
}: CurrencyProps) => {
  const [value, setValue] = useState(defValue);

  useEffect(() => {
    setValue(defValue);
  }, [defValue]);

  return (
    <InputNumber
      mode="currency"
      currency="USD"
      locale="en-US"
      value={value}
      onChange={(e) => {
        setValue(e.value);
        onChange(e.value);
      }}
      onBlur={() => {
        onBlur();
      }}
      onKeyDown={(event) => {
        if (event.code === 'Minus' && !!value && value > 0) {
          setValue(-1 * value);
          onChange(-1 * value);
        }
      }}
      className={`w-full ${hasError && 'p-invalid'} printHide`}
      inputClassName="w-full blackText text-standard text-right"
      disabled={disabled}
      tooltip={errorMessage}
    />
  );
};

export default Currency;
